import { render, staticRenderFns } from "./CPagination.vue?vue&type=template&id=9ae1481c&scoped=true&"
import script from "./CPagination.vue?vue&type=script&lang=js&"
export * from "./CPagination.vue?vue&type=script&lang=js&"
import style0 from "./CPagination.vue?vue&type=style&index=0&id=9ae1481c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae1481c",
  null
  
)

export default component.exports